import React from "react";
import { Img } from "@/components/image";
import { CarouselItem } from "@/components/ui/carousel";
import { MultiDietReviewsStars } from "@/features/static-builder/components/multidiet-reviews-carousel";
import type { MultiDietReviewType } from "@/features/static-builder/types/multidiet-reviews.type";

export const MultiDietReviewsCarouselItem = ({
  review,
  strapiUrl,
}: {
  review: MultiDietReviewType;
  strapiUrl: string;
}) => {
  return (
    <CarouselItem className="flex min-h-[350px] xs:min-h-[300px] basis-[70%] flex-col justify-between rounded-2xl border border-brand-grey2 p-6 first:ml-4 md:basis-1/3 lg:min-h-[250px] xl:min-h-[224px]">
      {review.review && (
        <p className="text-brand-green2-300">{review.review}</p>
      )}
      {review.name && (
        <div className="flex flex-col justify-between gap-1 border-brand-grey2 border-t pt-4 md:flex-row md:items-center">
          <p className="line-clamp-1 font-medium text-base text-brand-green2-300 lg:text-lg">
            {review.name}, {review.city}
          </p>
          <MultiDietReviewsStars />
        </div>
      )}
    </CarouselItem>
  );
};
